import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import { useAuth } from '../Provider/AuthProvider';
import SearchOrderByTerm from '../pages/Caisse/SearchOrderByTerm';
import MyCartDropdown from '../pages/Caisse/MyCartDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import RetourConsigneModal from '../pages/Caisse/RetourConsigneModal';
import RetourAvoirModal from '../pages/Caisse/RetourAvoirModal';
import ChatButtonWithBadge from '../pages/Chat/ChatButtonWithBadge'; 

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }: any) => {
    const { user, login, changeOrder, changeProduct } = useAuth();
    const [modalOpen, setModalOpen] = useState(false);
    const [consigneModalOpen, setConsigneModalOpen] = useState(false);
    const [avoirModalOpen, setAvoirModalOpen] = useState(false);
    const [search, setSearch] = useState<boolean>(false);
    const activeEntityRef = useRef<HTMLLIElement | null>(null);
    const searchOptionRef = useRef<{ setSearchTermRef: (term: string) => void }>(null);
    const location = useLocation();
    const [cartKey, setCartKey] = useState(0); // Add this state

    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => { };

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const toggleConsigneModal = () => {
        setConsigneModalOpen(!consigneModalOpen);
    };

    const toggleAvoirModal = () => {
        setAvoirModalOpen(!avoirModalOpen);
    };

    const handleEntitySwitch = (entity: { entity: string; label: string }) => {
        const updatedUser = {
            ...user,
            entity: parseInt(entity.entity),
            entityname: entity.label,
        };
        login(updatedUser);
        changeOrder(null);
        localStorage.removeItem('cart');
        setCartKey(prev => prev + 1); // Update the key
        changeProduct([]);
        setModalOpen(false);
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header" style={{ width: '100%', maxWidth: '100%' }}>
                        <div className="d-flex align-items-center justify-content-between w-100">
                            {/* Left Section - Logo and Search */}
                            <div className="d-flex align-items-center">
                                <div className="navbar-brand-box horizontal-logo">
                                    <Link to="/" className="logo logo-dark">
                                        <span className="logo-sm">
                                            <img src={logoSm} alt="" height="22" />
                                        </span>
                                        <span className="logo-lg">
                                            <img src={logoDark} alt="" height="17" />
                                        </span>
                                    </Link>
                                    <Link to="/" className="logo logo-light">
                                        <span className="logo-sm">
                                            <img src={logoSm} alt="" height="22" />
                                        </span>
                                        <span className="logo-lg">
                                            <img src={logoLight} alt="" height="17" />
                                        </span>
                                    </Link>
                                </div>
                                <button
                                    onClick={toogleMenuBtn}
                                    type="button"
                                    className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                    style={{ display: "none" }}
                                    id="topnav-hamburger-icon"
                                >
                                    <span className="hamburger-icon">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>
                                </button>
                                <SearchOrderByTerm ref={searchOptionRef} />
                            </div>

                            <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
                                <h4 className="mb-0 fs-16 fw-bold text-success ">
                                    {user?.entityname}
                                </h4>
                                {user?.entities?.length > 1 && (
                                    <button
                                        onClick={toggleModal}
                                        title="Basculer l'entité"
                                        className="btn btn-ghost-secondary btn-icon"
                                    >
                                        <i className="ri-arrow-left-right-line fs-20"></i>
                                    </button>
                                )}
                            </div>

                            <div className="d-flex align-items-center">
                                {location.pathname === '/caisse' && (
                                    <>
                                        <Button
                                            color="info"
                                            className="me-2"
                                            onClick={toggleAvoirModal}
                                        >
                                            <i className="ri-file-text-line me-1"></i>
                                            Retour Avoir
                                        </Button>
                                        <Button
                                            color="warning"
                                            className="me-2"
                                            onClick={toggleConsigneModal}
                                        >
                                            <i className="ri-arrow-left-right-line me-1"></i>
                                            Retour Consigne
                                        </Button>
                                    </>
                                )}

                                {location.pathname === '/vendeur' && (
                                    <MyCartDropdown key={cartKey} />
                                )}                                
                                <Dropdown
                                    isOpen={search}
                                    toggle={toogleSearch}
                                    className="d-md-none topbar-head-dropdown header-item">
                                    {/*<DropdownToggle*/}
                                    {/*    type="button"*/}
                                    {/*    tag="button"*/}
                                    {/*    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"*/}
                                    {/*>*/}
                                    {/*    <i className="bx bx-search fs-22"></i>*/}
                                    {/*</DropdownToggle>*/}
                                    <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                        <Form className="p-3">
                                            <div className="form-group m-0">
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search ..."
                                                        aria-label="Recipient's username"
                                                    />
                                                    <button className="btn btn-primary" type="submit">
                                                        <i className="mdi mdi-magnify"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </Form>
                                    </DropdownMenu>
                                </Dropdown>
                                <NotificationDropdown />
                                <ChatButtonWithBadge />
                                <ProfileDropdown />
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <Modal isOpen={modalOpen} toggle={toggleModal} centered size="md">
                <ModalHeader toggle={toggleModal} className="fs-16 py-2">
                    Sélectionner une entité
                </ModalHeader>
                <ModalBody style={{ maxHeight: '300px', overflowY: 'auto', padding: '0.75rem' }}>
                    {user?.entities?.length > 0 ? (
                        <ul className="list-group">
                            {user.entities.map((entity: { entity: string; label: string }) => (
                                <li
                                    key={entity.entity}
                                    className={`list-group-item fs-14 ${user.entity === parseInt(entity.entity) ? 'active' : ''}`}
                                    onClick={() => handleEntitySwitch(entity)}
                                    style={{ cursor: 'pointer', padding: '0.75rem 1.25rem' }}
                                    ref={user.entity === parseInt(entity.entity) ? activeEntityRef : null}
                                >
                                    {entity.label}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-muted fs-14 mb-0">Aucune entité disponible.</p>
                    )}
                </ModalBody>
            </Modal>

            <RetourConsigneModal
                isOpen={consigneModalOpen}
                toggle={toggleConsigneModal}
                user={user}
            />

            <RetourAvoirModal
                isOpen={avoirModalOpen}
                toggle={toggleAvoirModal}
                user={user}
            />
        </React.Fragment>
    );
};

export default Header;